<template lang="pug">
  .grid.is-desktop-4.is-tablet-6.is-labs
    .column.u-mb-col(v-for="({ node }) in categories" :key="node.id")
      AppCardBox.help-category
        AppLink(:to="`/knowledgebase/${node.slug}`" :title="node.title" class="cardBox-url")
        AppIcon(:name="node.icon")
        h4  {{ node.title }}

</template>

<script>
import { Categories } from '~/graphql/Faq.gql';

export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  async asyncData({ app }) {
    try {
      const icons = {
        company: 'company',
        accounts: 'user',
        services: 'servicesIcon',
        legalities: 'legalIcon',
        resources: 'ballot',
        'open-source': 'github'
      };

      const { data } = await app.$api.query({
        query: Categories
      });

      const categories = data.categories.edges.filter(({ node }) => {
        if (!icons[node.slug]) {
          return false;
        }

        node.icon = icons[node.slug];

        return true;
      });

      return {
        categories
      };
    } catch (err) {
      console.error(err);
      return {
        categories: []
      };
    }
  }
};
</script>

<style lang="stylus">
.help
  &-category
    text-align: center

    .icon
      font-size: unitRes(30, 60)
      margin-bottom: unitRes(20, 40)
</style>

<i18n>
{
  "en": {
    "pageTitle":"Baianat help center",
    "pageDesc":"Here you can find common questions and all answers on the specific topics you need to know."
  },
  "ar": {
    "pageTitle":"مركز المساعدة",
    "pageDesc":"هنا يمكنك العثور على الاسئلة الشائعة وجميع الاجابات على المواضيع التي تريد معرفتها."
  }
}
</i18n>
